<template>
  <div class="roleManage">
    <el-dialog
      class="roleDialog"
      title="设置权限"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
    >
      <p class="roleName">当前角色名称: {{ currentRoleName }}</p>
      <el-tree
        ref="tree"
        :data="data"
        show-checkbox
        check-strictly
        node-key="id"
        :default-expanded-keys="expandedKeys"
        :default-checked-keys="checkedKeys"
        highlight-current
        :props="defaultProps"
      >
      </el-tree>
      <el-button class="buttonSuccess" type="success" @click="saveRoleMenu()"
        >保存</el-button
      >
    </el-dialog>
    <el-table
      :data="tableData"
      style="width: 100%"
      highlight-current-row
      stripe
    >
      <el-table-column prop="name" label="角色名称"> </el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{
            scope.row.status == 1 ? "正常" : "不可用"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注"> </el-table-column>
      <el-table-column prop="addTime" label="添加时间"> </el-table-column>
      <el-table-column min-width="100">
        <template slot-scope="scope">
          <div class="buttonList">
            <el-button
              type="primary"
              size="mini"
              @click="handleEdit(scope.row)"
              v-if="hasPermission('handleEdit')"
              >设置权限</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import permissionMixin from "../mixins/permission";
import { getRoleList, getRoleMenuListByRoleId, saveRoleMenu } from "../api/";
import qs from "qs";
export default {
  mixins: [permissionMixin],
  data() {
    return {
      userInfo: {
        name: "",
        role: "",
      },
      data: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      dialogVisible: false,
      currentRoleName: "",
      checkRoleId: "",
      tableData: [],
      //展开的节点
      expandedKeys: [],
      //选中的节点
      checkedKeys: [],
    };
  },
  //获取localsession
  created() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    console.log(this.userInfo, "userInfo");
  },
  methods: {
    getData() {
      getRoleList().then((res) => {
        if (res.data.code === 200) {
          this.tableData = res.data.data;
          console.log("tableData", this.tableData);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleEdit(row) {
      this.dialogVisible = true;
      this.currentRoleName = row.name;
      const roleId = row.id;
      this.checkRoleId = roleId;
      const params = qs.stringify({
        roleId: this.userInfo.role,
        currentRoleId: roleId,
      });
      getRoleMenuListByRoleId(
        "web/roleMenu/getRoleMenuListByRoleId",
        params
      ).then((res) => {
        if (res.data.code === 200) {
          this.data = res.data.data;
          // 重置勾选状态
          this.checkedKeys = [];
          this.expandedKeys = [];

          // 处理展开和勾选状态
          this.processMenuData(this.data);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 处理菜单数据
    processMenuData(menuData) {
      menuData.forEach((item) => {
        // 如果是父节点，添加到expandedKeys
        if (item.children && item.children.length > 0) {
          this.expandedKeys.push(item.id);
          // 递归处理子节点
          this.processMenuData(item.children);
        }

        // 只有checked为1的节点才会被勾选
        if (item.checked === 1) {
          this.checkedKeys.push(item.id);
        }
      });
    },
    saveRoleMenu() {
      // 获取所有被勾选的节点
      const checkedKeys = this.$refs["tree"].getCheckedKeys();
      console.log("checkedKeys", checkedKeys);
      // 获取所有半选中的节点（父节点）
      const halfCheckedKeys = this.$refs["tree"].getHalfCheckedKeys();
      console.log("halfCheckedKeys", halfCheckedKeys);
      // 合并所有需要保存的节点ID
      const allCheckedIds = [...checkedKeys, ...halfCheckedKeys];
      console.log("allCheckedIds", allCheckedIds);

      saveRoleMenu(
        {
          roleId: this.checkRoleId,
          menuIds: allCheckedIds,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      ).then((res) => {
        if (res.data.code === 200) {
          this.$message.success(res.data.data);
          this.dialogVisible = false;
        } else {
          this.$message.error(res.data.data);
        }
      });

      // 重置状态
      this.checkedKeys = [];
      this.expandedKeys = [];
    },
    //弹窗关闭
    handleClose() {
      // 手动关闭对话框
      this.dialogVisible = false;
      this.checkedKeys = [];
      this.expandedKeys = [];
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
<style lang="less" scoped>
.roleManage {
  display: flex;
  .roleDialog {
    text-align: center;

    .roleName {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
      text-align: center;
    }
    .buttonSuccess {
      margin: auto;
    }
  }
}
</style>
